import { render, staticRenderFns } from "./UserDropdown2.vue?vue&type=template&id=605015bf&"
import script from "./UserDropdown2.vue?vue&type=script&lang=js&"
export * from "./UserDropdown2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports